export enum Operation_History_Enum {
    /**
     * 船舶信息
     */
    LOGISTICS_MANAGEMENT_SHIP_MANAGEMENT_I = 1,
    /**
     * 货主找船需求
     */
    LOGISTICS_MANAGEMENT_SHIPPING_DEMAND_SHIPPER_DEMAND = 2,
    /**
     * 船运需求发布
     */
    LOGISTICS_MANAGEMENT_SHIPPING_DEMAND_PUBLISH = 3,
    /**
     * 船运单
     */
    LOGISTICS_MANAGEMENT_SHIPPING_ORDER = 4,
    /**
     * 油品订单
     * */
    OIL_ORDER = 5,
    /**
     * 补录订单（来源后台）
     */
    RECORD_ORDER = 12,
    /**
     * 交易订单（来源客户）
     */
    TRADE_ORDER = 13,
    /**
     * 商品管理 - 寄售商品详情
     */
    PRODUCT_CONSIGNMENT_DETAIL = 14,
    /**
     * 商品管理 - 团购商品详情
     */
    PRODUCT_GROUP_PURCHASE_DETAIL = 15,
    /**
     * 商品管理 - 捡漏商品详情
     */
    PRODUCT_BARGAIN_DETAIL = 16,
    /**
     * 交易管理 - 专区合同详情
     */
    ZONE_CONTRACT_DETAIL = 17
}
